import React from 'react'

import * as S from './styles'

const Box = ({ icon, title, children, style }) => {
    return (
        <S.Container style={style} >
            <h1><i className={icon}/> {title}</h1>
            <S.Bar />
            <S.Body>
                {children}
            </S.Body>
        </S.Container>
    )
}

export default Box;
